import React from 'react';
import './EstimatedReachWidget.scss';
import PropTypes from 'prop-types';
import Widget from '../../../../common/Widget/Widget';
import { formatNumberToUnits } from '../../../../../utils/NumberUtils';

const EstimatedReachWidget = ({ getReachNumber, params, reachType, title, isAclSpinner }) => (
  <div className="estimated-reach-component">
    <span className="estimated-reach-label">{title}: </span>
    <div className="reach">
      <Widget
        name="EstimatedReachWidget"
        dataService={getReachNumber}
        dataServiceParams={params}
        renderOnValueChange={params}
        onRender={(reachNumber) => {
          const numDecimals = reachNumber >= 1000000 ? 3 : 1;
          const reach = `${formatNumberToUnits(reachNumber, numDecimals)} ${reachType}`;
          return <span>{reach}</span>;
        }}
        isSmallSpinner={true}
        style={{ width: '155px' }}
        isAclSpinner={isAclSpinner}
      />
    </div>
  </div>
);

EstimatedReachWidget.propTypes = {
  getReachNumber: PropTypes.func.isRequired,
  params: PropTypes.array.isRequired,
  reachType: PropTypes.string,
  title: PropTypes.string,
  isAclSpinner: PropTypes.bool,
};

EstimatedReachWidget.defaultProps = {
  title: 'Estimated reach',
  isAclSpinner: false,
};

export default EstimatedReachWidget;
